import { render, staticRenderFns } from "./bankSetPeru.vue?vue&type=template&id=34f4b1ae&scoped=true"
import script from "./bankSetPeru.vue?vue&type=script&lang=js"
export * from "./bankSetPeru.vue?vue&type=script&lang=js"
import style0 from "./bankSetPeru.vue?vue&type=style&index=0&id=34f4b1ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f4b1ae",
  null
  
)

export default component.exports